export interface ProductoInstitucionPais{
    iddecinvproyectoprodtermin: number,
    idpais: number,
    instituciontitular: string,
    iddecinvproductoinstitucionpais: number,
    ultimoCambio: Date
}

export function getVoidProductoInstitucionPais():ProductoInstitucionPais{
    return{
        iddecinvproyectoprodtermin: 0,
        idpais: 1816,
        instituciontitular: "ESPOL",
        iddecinvproductoinstitucionpais: 0,        
        ultimoCambio: new Date()
    }
}

export function setProductoInstitucionPais(row: any):ProductoInstitucionPais{
    return{
        iddecinvproyectoprodtermin: row.iddecinvproyectoprodtermin??0,
        idpais: row.idpais??0,
        instituciontitular: row.instituciontitular??"",
        iddecinvproductoinstitucionpais: row.iddecinvproductoinstitucionpais??0,        
        ultimoCambio: row.ultimoCambio??new Date()
    }
}